import React, {FC} from "react";
import PageToolbar from "../../../app/components/common/PageToolbar";

type Props = {
}

const GroupMemberToolbar: FC<Props> = () => {

    return (
        <>
            <PageToolbar
                title={
                    <div className="user-page-title">
                        <h4>Thông tin nhóm người dùng</h4>
                    </div>
                }
            />
        </>
    )
}

export default GroupMemberToolbar;